module.exports = __webpack_public_path__ + "static/media/faqBalance-es-de.a0e09b6b.vtt";